var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.14279 5C2.95328 5 2 5.98389 2 7.15107V16.8416C2 18.0088 2.95332 19 4.14279 19H19.8572C21.0467 19 22 18.0088 22 16.8416V7.15107C22 5.98389 21.0467 5 19.8572 5H4.14279ZM4.24692 6.4001H19.7607L12.4243 13.2252C12.1574 13.4736 11.8586 13.4739 11.5909 13.2252L4.24692 6.4001ZM3.42846 7.56678L8.29458 12.0877L3.42846 16.8419V7.56678ZM20.5715 7.56678V16.8419L15.7202 12.0802L20.5715 7.56678ZM14.6934 13.0431L19.3287 17.6006H4.67847L9.32902 13.0506L10.6089 14.2391C11.3847 14.9596 12.631 14.9607 13.4066 14.2391L14.6934 13.0431Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.87039c42b877888664956fecdbe499d8.svg";
export { ForwardRef as ReactComponent };